// extracted by mini-css-extract-plugin
export default {"leftBar":"style_leftBar__Vn89n","_white":"style__white__C6WJN","logoPartner":"style_logoPartner__PNPgZ","img":"style_img__XRrjC"};